import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Input,
  Label,
  FormGroup
} from 'reactstrap';
import SelectComponent from '@componentes/select/select.component';
import * as commonActions from '@common/common.action';
import * as actions from '../../solicitacao.action';
import {
  tiposSolicitacoesEnum,
  statusSolicitacoesEnumList,
  statusSolicitacoesEnum
} from '../../solicitacao.utils';
import SolicitacaoApi from '../../solicitacao.api';
import CommonFunctions from '@common/util/functions.common';
import IntlMessage from '../../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

function ModalDetalhesSolicitacao({
  showModal,
  onModal,
  itemSelecionado,
  setItemSelecionado
}) {
  const dispatch = useDispatch();
  const usuario = useSelector(state => state.usuario);
  const totalSolicitado = useSelector(
    state => state.solicitacao.totalSolicitado
  );

  const [modalAberto, setModalAberto] = useState(false);
  const [solicitacao, setSolicitacao] = useState({});

  const intl = useIntl();

	function translate(key) {
	  return intl.formatMessage({ id: key });
	}

  useEffect(() => {
    setModalAberto(showModal);
    dispatch(commonActions.showModal(showModal));
    setSolicitacao({
      ...itemSelecionado,
      status: statusSolicitacoesEnumList.find(
        x => x.value === itemSelecionado.statusEnum
      )
    });
  }, [showModal, itemSelecionado]);

  const toggle = () => {
    setModalAberto(!modalAberto);
    dispatch(commonActions.showModal(!modalAberto));
    onModal(!modalAberto);
  };

  const salvar = () => {
    const { id, status, laudo } = solicitacao;
    const body = { id, status: status.value, laudo };

    dispatch(commonActions.showFadeCarregando(true));
    SolicitacaoApi.put(body).then(() => {
      dispatch(commonActions.showFadeCarregando(false));
      toggle();
      const mensagem = `${<IntlMessage id='general.requestsPanel.requestChangedSuccessfully' />}`;
      dispatch(commonActions.showAlerta('sucesso', mensagem, 3000));

      const { value, label } = statusSolicitacoesEnumList.find(
        x => x.value === status.value
      );
      if (
        itemSelecionado.statusEnum === statusSolicitacoesEnum.SOLICITADO &&
        body.status !== statusSolicitacoesEnum.SOLICITADO
      ) {
        dispatch(actions.setTotalSolicitado(totalSolicitado - 1));
      }

      if (
        itemSelecionado.statusEnum !== statusSolicitacoesEnum.SOLICITADO &&
        body.status === statusSolicitacoesEnum.SOLICITADO
      ) {
        dispatch(actions.setTotalSolicitado(totalSolicitado + 1));
      }

      setItemSelecionado({
        ...itemSelecionado,
        status: label,
        statusEnum: value,
        usuarioExecutante: usuario.usuario,
        dataAlteracao: CommonFunctions.formatDateHour(new Date().toISOString())
      });
    });
  };

  return (
    <React.Fragment>
      <div>
        <Modal
          className='modal-lg'
          centered
          backdrop={false}
          keyboard={true}
          isOpen={modalAberto}
          toggle={toggle}
        >
          <ModalHeader toggle={toggle}><IntlMessage id="general.requestsPanel.requestDetails" /></ModalHeader>

          <ModalBody>
            <Row>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id="general.requestsPanel.date" />:</Label>
                  <Input value={solicitacao.dataCadastro} readOnly={true} />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id="general.requestsPanel.requestingUser" />:</Label>
                  <Input
                    value={solicitacao.usuarioSolicitante}
                    readOnly={true}
                  />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id="general.requestsPanel.executingUser" />:</Label>
                  <Input
                    value={solicitacao.usuarioExecutante}
                    readOnly={true}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id="general.requestsPanel.exam" />:</Label>
                  <Input value={solicitacao.nrExame} readOnly={true} />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id="general.requestsPanel.type" />:</Label>
                  <Input value={solicitacao.tipo} readOnly={true} />
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id="general.requestsPanel.status" />:</Label>
                  <SelectComponent
                    options={statusSolicitacoesEnumList}
                    value={solicitacao.status}
                    onChange={status =>
                      setSolicitacao({ ...solicitacao, status })
                    }
                    placeholder={translate("general.requestsPanel.selectStatus")}
                    styles={{ borderColor: 'transparent' }}
                  />
                </FormGroup>
              </Col>
            </Row>
            {solicitacao.tipoEnum === tiposSolicitacoesEnum.NOVO_CORTE && (
              <Row>
                <Col>
                  <FormGroup>
                    <Label><IntlMessage id="general.requestsPanel.bottle" />:</Label>
                    <Input value={solicitacao.frasco} readOnly={true} />
                  </FormGroup>
                </Col>
              </Row>
            )}
            {solicitacao.tipoEnum === tiposSolicitacoesEnum.APROFUNDAMENTO && (
              <div>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label><IntlMessage id="general.requestsPanel.block" />:</Label>
                      <Input value={solicitacao.bloco} readOnly={true} />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label><IntlMessage id="general.requestsPanel.colorations" />:</Label>
                      <Input
                        value={solicitacao.coloracoesFormated}
                        readOnly={true}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            )}
            <Row>
              <Col>
                <FormGroup>
                  <Label><IntlMessage id="general.requestsPanel.comment" />:</Label>
                  <Input
                    readOnly={true}
                    type='textarea'
                    rows={3}
                    value={solicitacao.comentario}
                  />
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>

          <ModalFooter>
            <Button
              onClick={toggle}
              className={`button-cancel`}
              color='secondary'
            >
              <IntlMessage id="general.requestsPanel.close" />
            </Button>
            <Button color='primary' onClick={salvar}>
              <IntlMessage id="general.requestsPanel.save" />
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    </React.Fragment>
  );
}

export default ModalDetalhesSolicitacao;



// WEBPACK FOOTER //
// ./src/pages/solicitacao/Solicitacoes/Detalhes/index.js